export default "__VITE_ASSET__CXv5C05a__"